module.exports = __webpack_public_path__ + "assets/img/certificating.7b470af6.svg";